export const RolesResource = {
  name: "Roles",
  path: "/user-management/roles",
  access: ["read-roles"],
};
